import appData from '@/data/appData.json';

// LocalStorage anahtarları
export const STORAGE_KEYS = {
  NODES: 'nodes',
  CURRENT_PAGE: 'currentPage',
  NODE_CONFIGS: 'nodeConfigs',
  APPLICATIONS: 'applications'
};

// JSON dosyasından veri okuma
export const getFromJson = (key) => {
  try {
    return appData[key] || null;
  } catch (error) {
    console.error(`JSON dosyasından veri okunurken hata: ${error}`);
    return null;
  }
};

// LocalStorage'dan veri okuma
export const getFromStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    // Eğer LocalStorage'da veri yoksa JSON dosyasından oku
    return getFromJson(key) || defaultValue;
  } catch (error) {
    console.error(`LocalStorage'dan veri okunurken hata: ${error}`);
    return defaultValue;
  }
};

// LocalStorage'a veri yazma
export const saveToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error(`LocalStorage'a veri yazılırken hata: ${error}`);
    return false;
  }
};

// LocalStorage'dan veri silme
export const removeFromStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error(`LocalStorage'dan veri silinirken hata: ${error}`);
    return false;
  }
};

// Tüm verileri sıfırla ve JSON dosyasındaki varsayılan değerlere dön
export const resetToDefaults = () => {
  try {
    Object.keys(STORAGE_KEYS).forEach(key => {
      const defaultValue = getFromJson(STORAGE_KEYS[key]);
      if (defaultValue !== null) {
        saveToStorage(STORAGE_KEYS[key], defaultValue);
      }
    });
    return true;
  } catch (error) {
    console.error(`Verileri sıfırlarken hata: ${error}`);
    return false;
  }
}; 